// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-options-form .form-group {\n    border-bottom: 1px solid #E3E3E3;\n}\n\n.cart-order-product.col-6 {\n    padding-left: 0px;\n    padding-right: 0px;\n}\n\n.cart-order-product ul {\n    list-style: none;\n    padding-left: 0;\n}\n\n.pick-up-time-label {\n    align-self: center;\n}\n\n.pick-up-time-label label {\n    margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
